<template>
	<span v-if="visible" class="fd-datetime" :class="clazz" :style="style"><span class="fd-datetime-formatted">{{ formatted }}</span></span>
</template>

<script setup lang="ts">
import useEditor, {type EditorProps, editorProps} from "../Editor";
import {computed} from "vue";
import {injectEnv} from "../../Environment";
import type {DateTime} from "@t/fd/editor/DateTime";
import {parseDate} from "@t/util/DateUtil";

const uprops = defineProps({...editorProps});
const props = uprops as EditorProps;

const dt = computed<DateTime>(() => props.part as DateTime);
const env = injectEnv();

const {visible, value, clazz, style, optional} = useEditor(props);

const parsedDate = computed(() => {
	return parseDate(value.value);
});

const emptyDate = computed(() => {
	if (dt.value.empty) return dt.value.empty;
	return "";
});

const formatted = computed(() => {
	if (!value.value) return emptyDate.value;
	switch (dt.value.format) {
		case "date":
			return formattedDate.value;
		case "time":
			return formattedTime.value;
		default:
			return formattedStandard.value;
	}
});

const formattedDate = computed(() => {
	const parsed = parsedDate.value;
	return parsed.date ? env.formats.dateFormat.format(parsed.date) : emptyDate.value;
});

const formattedTime = computed(() => {
	const parsed = parsedDate.value;
	return parsed.date && !parsed.wholeDay ? env.formats.hourMinFormat.format(parsed.date) : emptyDate.value;
});

const formattedStandard = computed(() => {
	const parsed = parsedDate.value;
	return parsed.date ? (parsed.wholeDay ? env.formats.dateFormat.format(parsed.date) : env.formats.dateTimeFormat.format(parsed.date)) : emptyDate.value;
});
</script>
